// extracted by mini-css-extract-plugin
export default {"btn_zamknij":"ZamknijBtn_btn_zamknij__L8Myn"};